module.exports = __webpack_public_path__ + "brb-phase.png?1ef153e0a23f988fb22ab14458152392";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brb-phase.png
// module id = 132
// module chunks = 0